import React, { useEffect, useReducer } from 'react'
import { useImageTestQuery } from '../api/react-query/log'
import { message } from 'antd'
import { simpleReducer } from '../helper'

export default function ImageTestScreen () {
  const [state, setState] = useReducer(simpleReducer, { list: null })
  const {
    data: imageTestData,
    isSuccess,
    isError,
    isLoading
  } = useImageTestQuery()

  useEffect(() => {
    if (isSuccess && imageTestData) {
      setState({ list: imageTestData })
    } else if (isError) {
      message.error('Ошибка получения изображений')
    }
  }, [isSuccess, isError])

  return (
    <>
      {isLoading && <div>Загрузка...</div>}
      {state?.list?.length && (
        state?.list?.map((image) => (
          <img key={image} src={`/api/public/file/${image}?r=${Math.random()}`} alt='' />
        ))
      )}
    </>
  )
}
